<template>
  <modal class="q-modal lacpitem" name="lacp-item-modal" :class="ifTop"
       transition="nice-modal-fade"
       :width="580"
       :min-width="580"
       :delay="100"
       :draggable="'.modal-header'"
       :clickToClose="false"
       :adaptive="true"
       @opened="Opened"
       classes='q-v--modal'>
    <div class="modal-content">
      <div class="modal-header">{{modalTitle}}</div>
      <div class="icon-btn_close modal-close" @click="onClose()"></div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="modal-body">
          <div class="modal-container">
            <div class="form">
              <div class="formRow dt">
                <div class="dt-r">
                  <span class="title dt-c">{{$t('lag.groupNumber')}}:</span>
                  <span class="forminput dt-c" v-if="type === 'add'">
                    <input name="ID" class="form-control group-number-input" type="text" :class="{'error': errors.has('ID') || alreadyExist }" v-model="groupId" v-validate="'required|numeric|max_value:8|min_value:1'" @keyup="onBlur" @change="onBlur" @keypress="onlyNumber" min="1">
                  </span>
                  <span class="forminput dt-c" v-else>{{groupId}}</span>
                </div>
                <div class="dt-r">
                  <div class="dt-c"></div>
                  <div class="errorMessage dt-c" v-show="errors.has('ID') || alreadyExist">{{ setErrorMessage(errors.first('ID')) }}</div>
                </div>
              </div>
              <div class="formRow" style="margin-top:10px;">
                <span class="title">{{$t('lag.modeColon')}}</span>
                <div class="radio">
                  <radio class="permit" :label="$t('lag.LACP')" :checked="isModeChecked(radioItems[0])" @click.native="onModeSelection(radioItems[0])" :id="'radio-lacp'"></radio>
                  <radio :label="$t('mactable.static')" :checked="isModeChecked(radioItems[1])" @click.native="onModeSelection(radioItems[1])" :id="'radio-static'"></radio>
                </div>
              </div>
              <div class="formRow">
                <div class="port-members">{{$t('vlan.vlanCong')}}</div>
                <div class="forminput" style="margin-top:10px;">{{$t('selected')}}:
                  <span class="dynamic-color">{{selectedList.length}}</span>
                  <span v-if="selectedList.length === 4">
                    <span class="icon-warning"></span>
                    <span style="color:#2F2F2F;">{{$t('lag.limit')}}</span>
                  </span>
                </div>
                <div class="forminput">
                  <div class="port-select">
                    <table>
                      <tr class="table-header">
                        <td style="width:24%;">{{$t('overview.portNo')}}</td>
                        <td :style="{ width: 76/(portNumber) + '%' }" v-for="num in portNumber" :key="num">{{num}}</td>
                      </tr>
                      <tr class="table-body">
                        <td class="table-body-content" style="width:24%;">{{$t('selected')}}</td>
                        <td class="table-body-content" :style="{ width: 76/(portNumber) + '%' }" v-for="num in portNumber" :key="num">
                          <div class="formlabel fontB subitem" @click="onSelection(num)" :title="getTips((num))">
                              <checkbox class="q-checkbox-label" :checked="isItemChecked(num)" :disabled="getDisabled(num)" :id="'checkbox-' + (num)"></checkbox>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
              <div class="formRow note">
                <icon-remind class="remind"></icon-remind>
                <span class="note-title">{{$t('lag.note')}}</span>
              </div>
              <div class="formRow note">
                <icon-remind class="remind"></icon-remind>
                <span class="note-title">{{$t('lag.resetNote')}}</span>
              </div>
            </div>
            <div class="errorMessage" v-if="isShowError">{{errorMessage}}</div>
          </div>
        </div>
      </scrollbar>
      <div class="modal-footer">
        <div class="footer-left">
        </div>
        <div class="footer-right">
          <button class="q-button blue-btn-full" @click="onSaveClick()" :disabled="!saveBtn" :title="$t('save')">{{$t('save')}}</button>
          <button class="q-button" @click="onClose()" :title="$t('cancel')">{{$t('cancel')}}</button>
        </div>
      </div>
      <popup-confirm :selHeight="217" :isDisplayFlex=true name="enable-laggr-modal" :dialog-header="$t('lag.note')" :dialog-content="''" icon="w" type="s" :callback="goSave" :pwdWarn=true />
      <toast v-if="showToast" />
    </div>
    <div class="modal-mask" v-if="showToast" />
  </modal>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import config from '../config'
import checkbox from './module/Checkbox'
import toggle from './module/Toggle'
import Radio from './module/Radio'
import iconRemind from '../assets/svg/ic_system_remind.svg'
import { cloneDeep } from 'lodash'
export default {
  name: 'LacpItem',
  props: {
    selectItem: Object,
    type: String,
    existNum: Object,
    onChange: Function
  },
  components: {
    checkbox,
    toggle,
    Radio,
    iconRemind
  },
  data () {
    return {
      modalname: 'lacp-item-modal',
      aggrMode: config.constant.AggrMode,
      showModal: true,
      groupId: null,
      selectedList: [],
      saveBtn: false,
      errorMessage: '',
      isShowError: false,
      alreadyExist: false,
      radioItems: ['LACP_ACTIVE', 'LACP_STATIC'],
      mode: 'LACP_ACTIVE',
      checkBoxDisabledList: [],
      portConfList: [],
      aclportList: [],
      tempExistPort: null,
      manageMentVlan: '1',
      group: []
    }
  },
  created () {
    this.getAclPort()
      .then((result) => {
        this.aclportList = result.data.result.idx
      }).catch((err) => {
        this.$log.error(err)
      })
  },
  beforeMount () {
    let me = this
    this.axios.all([this.getPortStatus(), this.getPortConfigure()])
      .then(this.axios.spread(function (status, config) {
        let statusData = status.data.result
        let confData = config.data.result
        let temp = []
        if (confData.length > 0) {
          confData.forEach(element => {
            if (Number(element.key) <= me.portNumber) {
              temp.push(element)
            }
          })
        }
        if (statusData.length > 0) {
          statusData.forEach((element, index) => {
            if (Number(element.key) <= me.portNumber && Number(element.key) === Number(temp[index].key)) {
              temp[index].val.Link = element.val.Link
            }
          })
        }
        me.portConfList = temp
      }))
  },
  watch: {
    selectItem: function (value) {
      this.selectedList = []
      this.tempExistPort = JSON.parse(JSON.stringify(this.existNum.port))
      if (value === null) {
        this.groupId = null
      } else {
        if (value.key) {
          this.groupId = value.key
          value.val.AggrMode === 1 ? this.mode = 'LACP_ACTIVE' : this.mode = 'LACP_STATIC'
          if (value.val.PortMembers.length === 0) {
            this.mode = 'LACP_ACTIVE'
          }
          this.selectItem.val.PortMembers.forEach(element => {
            this.selectedList.push(parseInt(element))
            let idx = this.tempExistPort.indexOf(parseInt(element))
            this.tempExistPort.splice(idx, 1)
          })
          this.checkBoxDisabled()
        } else {
          this.groupId = null
          this.mode = 'LACP_ACTIVE'
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'openModal',
      'closeModal'
    ]),
    Opened (event) {
      const modal = document.querySelector('.v--modal-box.q-v--modal')
      let height = document.body.clientHeight
      let temph = (height > 465) ? 465 : height - 90
      if (modal) {
        modal.style.height = temph + 'px'
        modal.style.top = 'calc(50% - ' + (temph / 2) + 'px'
      }
      this.$refs.scrollbar.onResize()
      this.getGroup()
    },
    setInitial: function () {
      this.$store.commit('updateToast', false)
      this.groupId = null
      this.saveBtn = false
      this.selectedList = []
      this.enable = false
      this.isShowError = false
      this.alreadyExist = false
      this.checkBoxDisabledList = []
    },
    checkBoxDisabled: function () {
      if (this.selectedList.length > 0) {
        let item = this.selectedList[0]
        let defaultList = (config.productDiff[this.systemHostInfo.Product].isMultiSpeed) ? (item <= config.productDiff[this.systemHostInfo.Product].minNumber ? cloneDeep(config.productDiff[this.systemHostInfo.Product].speed2Group) : cloneDeep(config.productDiff[this.systemHostInfo.Product].speed1Group)) : []
        let controlItem = this.portConfList[item - 1]
        this.portConfList.forEach(element => {
          if (controlItem.val.AutoMode) {
            if (controlItem.val.AutoMode !== element.val.AutoMode) {
              if (defaultList.indexOf(Number(element.key)) < 0) {
                defaultList.push(Number(element.key))
              }
            } else if (controlItem.val.AutoMode === element.val.AutoMode && element.val.FC !== controlItem.val.FC) {
              if (defaultList.indexOf(Number(element.key)) < 0) {
                defaultList.push(Number(element.key))
              }
            }
          } else {
            if (controlItem.val.AutoMode !== element.val.AutoMode || element.val.Fdx !== controlItem.val.Fdx || element.val.Speed !== controlItem.val.Speed || element.val.FC !== controlItem.val.FC) {
              if (defaultList.indexOf(Number(element.key)) < 0) {
                defaultList.push(Number(element.key))
              }
            }
          }
        })
        this.tempExistPort.forEach(element => {
          let key = Number(element)
          if (defaultList.indexOf(key) < 0) {
            defaultList.push(key)
          }
        })
        this.checkBoxDisabledList = defaultList
      } else {
        let defaultList = []
        this.tempExistPort.forEach(element => {
          let key = Number(element)
          if (defaultList.indexOf(key) < 0) {
            defaultList.push(key)
          }
        })
        this.checkBoxDisabledList = defaultList
      }
    },
    isItemChecked: function (item) {
      let index = this.selectedList.indexOf(item)
      return (index > -1)
    },
    onSelection: function (item) {
      if (!this.aclportList || this.aclportList.indexOf('' + item) < 0) {
        if (this.checkBoxDisabledList.indexOf(item) < 0) {
          let index = this.selectedList.indexOf(item)
          if (index > -1) {
            this.selectedList.splice(index, 1)
            this.checkValidation()
          } else if (this.selectedList.length < 4) {
            this.selectedList.push(item)
            this.checkValidation()
          }
          this.checkBoxDisabled()
        }
      }
    },
    port2String: function (portList) {
      let tempArr = []
      portList.forEach(element => {
        tempArr.push(element + '')
      })
      return tempArr
    },
    getMode: function (type) {
      if (type) {
        return 'LACP_ACTIVE'
      } else {
        return 'LACP_STATIC'
      }
    },
    isModeChecked: function (item) {
      return (item === this.mode)
    },
    onModeSelection: function (item) {
      this.mode = item
      this.checkValidation()
    },
    onSwitchBtn: function () {
      this.enable = !this.enable
      this.checkValidation()
    },
    onOpen () {
      this.openModal(this.modalname)
      this.$modal.show(this.modalname)
    },
    onClose () {
      this.setInitial()
      this.closeModal(this.modalname)
      this.$modal.hide(this.modalname)
    },
    onBlur: function (event) {
      this.checkValidation()
    },
    checkCellValidation: function () {
      this.isShowError = false
      if (this.selectedList.length > 1) {
        this.saveBtn = true
      } else {
        this.saveBtn = false
      }
    },
    goSave: async function () {
      this.$modal.hide('enable-laggr-modal')
      this.closeModal('enable-laggr-modal')
      this.$store.commit('updateToast', true)
      let data = {
        key: this.groupId,
        val: {
          PortMembers: this.port2String(this.selectedList),
          AggrMode: this.aggrMode[this.mode]
        }
      }
      if (this.type === 'add') {
        this.addLagStatus(data).then(async (res) => {
          this.$store.commit('updateToast', false)
          let error = res.data.error_code
          if (error !== 200) {
            this.errorMessage = error.message
            this.isShowError = true
          } else {
            await this.closeModal(this.modalname)
            await this.$modal.hide(this.modalname)
            setTimeout(() => {
              this.onChange()
              this.setInitial()
            }, 100)
          }
        })
          .catch(error => {
            this.$store.commit('updateToast', false)
            this.$log.error(error)
          })
      } else {
        this.setLagStatus(data).then(async (res) => {
          this.$store.commit('updateToast', false)
          let error = res.data.error_code
          if (error !== 200) {
            this.errorMessage = error.message
            this.isShowError = true
          } else {
            await this.closeModal(this.modalname)
            await this.$modal.hide(this.modalname)
            setTimeout(() => {
              this.onChange()
              this.setInitial()
            }, 100)
          }
        }).catch(error => {
          this.$store.commit('updateToast', false)
          this.$log.error(error)
        })
      }
    },
    onSaveClick: async function () {
      let me = this
      this.getVlan().then((res) => {
        if (!me.checkPortValidate()) {
          me.errorMessage = me.$t('errorMessage.LAGPortused')
          me.isShowError = true
          me.saveBtn = false
        } else if (me.checkManageMent(this.groupId, res.data.result) && me.checkLagMember(res.data.result)) {
          me.errorMessage = me.$t('vlan.manageEmpty', {0: me.manageMentVlan})
          me.isShowError = true
          me.saveBtn = false
        } else {
          me.isShowError = false
          me.goSave()
        }
      })
    },
    checkValidation: function () {
      if (this.type === 'add' && this.existNum.key.indexOf(parseInt(this.groupId)) > -1) {
        this.alreadyExist = true
        this.saveBtn = false
      } else {
        this.alreadyExist = false
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.checkCellValidation()
          } else {
            this.saveBtn = false
          }
        }).catch(() => {
          this.saveBtn = false
        })
      }
    },
    checkPortValidate: function () {
      let result = true
      this.selectedList.forEach(element => {
        if (this.tempExistPort.indexOf(element) > -1) {
          result = false
        }
      })
      return result
    },
    setErrorMessage: function (data) {
      let message = ''
      if (this.alreadyExist) {
        message = this.$t('errorMessage.groupNumDuplicate')
      } else if (data) {
        if (data.indexOf('required') > -1) {
          message = this.$t('errorMessage.isReguired')
        } else {
          message = this.$t('errorMessage.lacpRange')
        }
      }
      return message
    },
    onlyNumber ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      let isFunctionKey = false
      switch (keyCode) {
        case 8:
          isFunctionKey = true
          break
      }
      if ((keyCode < 48 || keyCode > 57) && !isFunctionKey) { // 46 is dot
        $event.preventDefault()
      }
    },
    getTips (port) {
      let title = ''
      if (this.systemHostInfo.Product.includes('M5216-1T') && Number(port) === 17) {
        title = this.$t('lag.tenGdisabledTip')
      } else if (this.tempExistPort && this.tempExistPort.indexOf(port) > -1) {
        title = this.$t('errorMessage.LAGPortused')
      } else if (this.checkBoxDisabledList.indexOf(port) > -1) {
        title = this.$t('lag.disabledTip')
      } else if (this.aclportList && this.aclportList.indexOf('' + port) > -1) {
        title = this.$t('errorMessage.existInAcl')
      }
      return title
    },
    getDisabled (port) {
      if (this.checkBoxDisabledList.indexOf(port) > -1 || (this.aclportList && this.aclportList.indexOf('' + port) > -1)) {
        return true
      } else if (this.systemHostInfo.Product.includes('M5216-1T') && Number(port) === 17) {
        return true
      }
      return false
    },
    checkLagMember (vlanList) {
      let me = this
      let result = true
      let countMember = 0
      let countPort = 0
      let manageMentList = []
      vlanList.forEach((item) => {
        if (item.key === this.manageMentVlan) manageMentList = item
      })
      manageMentList.val.forEach((members) => {
        if (parseInt(members.Port) <= parseInt(me.lagStartNum)) { // check is trunk port or not
          countPort++
          if (me.selectedList.includes(parseInt(members.Port))) {
            countMember++
          }
        } else {
          if (me.groups[parseInt(members.Port) - (1 + parseInt(me.lagStartNum))].val.PortMembers.length > 0) { // confirm lacp has members
            result = false
          }
        }
      })
      if (countMember < countPort) result = false
      return result
    },
    checkManageMent (key, vlanList) {
      let result = false
      let lagNum = parseInt(key) + parseInt(this.lagStartNum)
      let manageMentList = []
      vlanList.forEach((item) => {
        if (item.key === this.manageMentVlan) manageMentList = item
      })
      manageMentList.val.forEach((item) => {
        if (parseInt(lagNum) === parseInt(item.Port)) result = true
      })
      return !result
    },
    getGroup: function () {
      this.getLagStatus()
        .then(res => {
          if (res.data && res.data.error_code === 200) {
            let data = []
            res.data.result.forEach(element => {
              if (Number(element.key) <= this.lagGroupMap.size) {
                data.push(element)
              }
            })
            this.groups = data
          }
        })
        .catch(error => {
          this.$log.error(error)
        })
    },
    ...mapActions(['setLagStatus', 'getPortConfigure', 'getAclPort', 'getPortStatus', 'getVlan', 'getLagStatus'])
  },
  computed: {
    ...mapState({
      portNumber: state => state.module.portNum,
      showToast: state => state.app.showToast,
      systemHostInfo: state => state.module.systemHostInfo,
      sysBoard: state => state.module.sysBoard,
      lagStartNum: state => state.module.lagStartNum,
      lagGroupMap: state => state.module.lagGroupMap
    }),
    ...mapGetters(['getTopModalName']),
    ifTop () {
      this.$log.debug('this.getTopModalName :' + this.getTopModalName)

      if (this.getTopModalName !== this.modalname) {
        return 'noTopModal'
      } else {
        return 'none'
      }
    },
    modalTitle () {
      if (this.type === 'add') {
        return this.$t('lag.addGroup')
      } else {
        return this.$t('lag.editGroup')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/variables.scss';
@import '../assets/scss/modal.scss';

.lacpitem {
  .modal-container {
    .formRow {
      margin-bottom: 10px;
      .title {
        width: 110px;
      }
      .group-number-input {
        width: 100px;
      }
      .forminput {
        margin: 0px 10px;
        .port-select {
          margin-top: 10px;
          >table {
            width: 100%;
            tr:last-child {
              border-bottom: 1px solid #e5e5e5;
            }
            .table-header {
              background: #e5e5e5;
              height: 40px;
              text-align: center;
              td {
                font-family: 'Roboto-M' !important;
                &:first-child {
                  text-align: initial;
                  padding-left: 16px;
                }
              }
            }
            .table-body {
              height: 40px;
              text-align: center;
              .q-checkbox-label {
                display: inline-block;
              }
              td {
                font-family: 'Roboto-R' !important;
                &:first-child {
                  text-align: initial;
                  padding-left: 16px;
                }
              }
            }
          }
        }
        .icon-warning {
          margin: 0px 0px 0px 10px;
          font-size: 12px;
          color: #F5A623;
        }
      }
      .radio {
        display: initial;
      }
      &.note {
        font-family: 'Roboto-R';
        font-size: 14px;
        color: #195A87;
        text-align: left;
        line-height: 18px;
        .remind {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        .note-title {
          line-height: 18px;
          vertical-align: text-bottom;
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/LacpItem.vue